<template>
  <div>
    <NoticePopup v-if="showNoticePopup" :close-popup-fn="closeEventPopup" :open-popup-fn="openEventPopup" />
  <div>
    <div v-if="multiSectionList && multiSectionList.length" class="multi-section-wrap">
      <div v-for="(sectionInfo, index) in multiSectionList" :key="sectionInfo.title + 'home_container' + index" class="multi-section-container">
        <DynamicSectionLoader :section-info="sectionInfo" v-on-display="sectionInfo"></DynamicSectionLoader>
      </div>
    </div>
  </div>
    <Footer v-if="!isBandLoading"></Footer>
  </div>
</template>
<script setup>
</script>
<script>
import { mapGetters, mapMutations } from 'vuex'
import NoticePopup from '@/components/notice/NoticePopup'
import DynamicSectionLoader from '@/components/section/DynamicSectionLoader'
import Footer from '@/components/Footer'
import { onDisplay } from '@/common/directives'
import { SESSION_STORAGE_NOTICE_POPUP_VIEW_KEY } from '@/common/constant'
import { getSessionStorage } from '@/common/util/storage.util'
import utils from '@/common/util/utils'
import { SET_CURRENT_MENU } from '@/store/types/mutations.type'

export default {
  name: 'Home',
  components: {
    NoticePopup,
    DynamicSectionLoader,
    Footer
  },
  directives: {
    onDisplay
  },
  data () {
    return {
      showNoticePopup: true,
      device: utils.cookies.getDevice()
    }
  },
  computed: {
    ...mapGetters(['multiSectionList', 'isBandLoading'])
  },
  methods: {
    ...mapMutations([SET_CURRENT_MENU]),
    closeEventPopup () {
      getSessionStorage().set(SESSION_STORAGE_NOTICE_POPUP_VIEW_KEY, 'y')
      this.showNoticePopup = false
    },
    openEventPopup () {
      this.showNoticePopup = true
    }
  },
  created () {
    this[SET_CURRENT_MENU]('home')
    if (this.device === 'mobile') {
      this.showNoticePopup = true
    }
  }
}
</script>
